<template>
  <v-dialog v-model="visible" max-width="700px">
    <v-card>
      <v-card-title class="text-uppercase">{{ titulo }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                class="my-1"
                label="Gestión"
                v-model="form.numero"
                type="number"
                min="2023"
                placeholder="2023, 2024, 2025, ..."
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.numero" :key="error" class="text-danger">{{ error }}</small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="validar"> Guardar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ModalFormMixin from '../mixins/modal-form-mixin';
import GestionesServices from '../services/gestion';
import { formatearErrores } from '../utils';

export default {
  mixins: [ModalFormMixin],
  data() {
    return {};
  },
  watch: {
    'form.numero': function () {
      this.errores.numero = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        numero: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        numero: data.numero,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    async registrar() {
      this.guardar();
    },
    async editar() {
      this.guardar();
    },
    async guardar() {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;

        if (this.form?.id) {
          response = await GestionesServices.update(this.form.id, this.form);
        } else {
          response = await GestionesServices.store(this.form);
        }

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>